import React from 'react';
import cn from 'classnames';
import {CloseIcon} from 'icons/svg';
import './style.scss';

/**
 * Figma `PopUpHeadButton / Close` (391:24375): a popup's close — `x-03` in a 24px blurred
 * circle. Every antd modal gets it by default (ConfigProvider in Application); `onDark` is
 * the variant for a close over a coloured header.
 */
export const FFPopupClose = ({onDark}: {onDark?: boolean}) => (
    <span className={cn('ff-popup-close', {'ff-popup-close--on-dark': onDark})} aria-hidden>
        <CloseIcon/>
    </span>
);
